<template>
    <div id="vehicle_ownership_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehicleOwnershipHeader" v-if="$route.params.id > 0">Update Asset Ownership</span>
                    <span class="page-title" id="vehicleOwnershipHeader" v-else>Add Asset Ownership</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackVehicleOwnershipList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="VehicleOwnershipForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="description">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description">
                                        <div class="field-error">{{description_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="value">Value:</label>
                                        <input type="text" class="form-control" v-model="value" id="value" placeholder="Enter Value" name="value">
                                        <div class="field-error">{{value_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="field-error"></strong>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createVehicleOwnershipBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateVehicleOwnership" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createVehicleOwnershipBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateVehicleOwnership" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueVehicleOwnershipBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateVehicleOwnership(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelVehicleOwnershipBtn" class="btn btn-tertiary" v-on:click.prevent="BackVehicleOwnershipList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>    
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

 



export default {
  name: "VehicleModelCreate",
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Asset Ownership | " +process.env.COPYRIGHT_NAME : "Create Asset Ownership | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    description: "",
    value: "",
    loading:false,
    description_error_msg: "",
    value_error_msg: ""
  }),
  watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_ownership') {
                        self.cantAccessPage = true;

                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {

        var self = this;
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");
        
        if (segments[3]) {
            self.loadVehicleOwnership();
        }
  },
  methods: {
            
    BackVehicleOwnershipList() {
      var self = this;
      self.$router.push("/assetownership/list");
    },

    CreateVehicleOwnership(flag) {
      var self = this;

      self.value = self.value.trim();
      self.description = self.description.trim();

      self.description_error_msg = "";
      self.value_error_msg = "";

      if (!self.description || self.description == null || self.description == "") {
        self.description_error_msg = "Description Required.";
      }

      if (!self.value || self.value == null || self.value == "") {
        self.value_error_msg = "Value Required.";
      }

      if (self.description_error_msg == "" && self.value_error_msg == "") {
        self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createVehicleOwnershipBtn").val("Updating ...");
                $("#createVehicleOwnershipBtn").prop("disabled", true);
                $("#cancelVehicleOwnershipBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueVehicleOwnershipBtn").val("Saving ...");
                    $("#createVehicleOwnershipBtn").prop("disabled", true);
                    $("#createAndContinueVehicleOwnershipBtn").prop("disabled", true);
                    $("#cancelVehicleOwnershipBtn").prop("disabled",true);

                }else{

                    $("#createVehicleOwnershipBtn").val("Saving ...");
                    $("#createVehicleOwnershipBtn").prop("disabled", true);
                    $("#createAndContinueVehicleOwnershipBtn").prop("disabled", true);
                    $("#cancelVehicleOwnershipBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/assetownership/create",
                type: "POST",
                data: {description: self.description,id: segments[3], value: self.value},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleOwnershipBtn").val("Update");
                        $("#createVehicleOwnershipBtn").prop("disabled", false);
                        $("#cancelVehicleOwnershipBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehicleOwnershipBtn").val("Save and Continue");
                            $("#createVehicleOwnershipBtn").prop("disabled", false);
                            $("#createAndContinueVehicleOwnershipBtn").prop("disabled", false);
                            $("#cancelVehicleOwnershipBtn").prop("disabled",false);

                        }else{

                            $("#createVehicleOwnershipBtn").val("Save");
                            $("#createVehicleOwnershipBtn").prop("disabled", false);
                            $("#createAndContinueVehicleOwnershipBtn").prop("disabled", false);
                            $("#cancelVehicleOwnershipBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            // $("#VehicleStatusForm").trigger("reset");
                            self.description = "";
                            self.value = "";

                        }else{
                            self.$router.push("/assetownership/list");
                        }
                        
                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleOwnershipBtn").val("Update");
                        $("#createVehicleOwnershipBtn").prop("disabled", false);
                        $("#cancelVehicleOwnershipBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#VehicleStatusForm").trigger("reset");
                            
                            $("#createAndContinueVehicleOwnershipBtn").val("Save and Continue");
                            $("#createVehicleOwnershipBtn").prop("disabled", false);
                            $("#createAndContinueVehicleOwnershipBtn").prop("disabled", false);
                            $("#cancelVehicleOwnershipBtn").prop("disabled",false);

                        }else{

                            $("#createVehicleOwnershipBtn").val("Save");
                            $("#createVehicleOwnershipBtn").prop("disabled", false);
                            $("#createAndContinueVehicleOwnershipBtn").prop("disabled", false);
                            $("#cancelVehicleOwnershipBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'asset-ownership-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }

     
    },

    loadVehicleOwnership() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/assetownership/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.description = data.content.description;
                    self.value = data.content.value;
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'asset-ownership-get-by-id')
            }
        });
    },
  }
};
</script>   


// WEBPACK FOOTER //
// src/components/AssetOwnershipCreate.vue